<template>
  <div class="form__wrapper">
    <form v-if="displayForm"
          @submit="onSubmit">
      <div class="row">
        <!-- left form -->
        <div class="col-lg-6 col-12">
          <!-- name -->
          <div class="d-flex w-100">
            <div class="form-group w-50 mr-3">
              <!-- first name -->
              <label for="firstName"
                     class="required">First Name</label>
              <input id="firstName"
                     v-model.trim="$v.form.firstName.$model"
                     type="text"
                     :class="['form-control', { 'form-control--error': $v.form.firstName.$error }]"
                     placeholder="First Name">

              <span v-if="$v.form.firstName.$error"
                    class="validation__error">
                Please enter your first name
              </span>
            </div>
            <!-- last name -->
            <div class="form-group w-50">
              <label for="lastName"
                     class="required">Last Name</label>
              <input id="lastName"
                     v-model.trim="$v.form.lastName.$model"
                     type="text"
                     :class="['form-control', { 'form-control--error': $v.form.lastName.$error }]"
                     placeholder="Last Name">

              <span v-if="$v.form.lastName.$error"
                    class="validation__error">
                Please enter your last name
              </span>
            </div>
          </div>
          <!-- organisation -->
          <div class="form-group">
            <label for="organisation"
                   class="required">Name / School Name</label>
            <input id="organisation "
                   v-model.trim="$v.form.organisation.$model"
                   type="text"
                   :class="['form-control', { 'form-control--error': $v.form.organisation.$error }]"
                   placeholder="School Name">

            <span v-if="$v.form.organisation.$error"
                  class="validation__error">
              Please enter your school name
            </span>
          </div>
          <!-- postcode -->
          <div class="form-group">
            <label for="postcode"
                   class="required">Postcode</label>
            <input id="postcode "
                   v-model.trim="$v.form.postcode.$model"
                   type="text"
                   :class="['form-control', { 'form-control--error': $v.form.postcode.$error }]"
                   placeholder="Postcode">

            <span v-if="$v.form.postcode.$error"
                  class="validation__error">
              Please enter your organisation's postcode
            </span>
          </div>
          <!-- Enquiry type -->
          <div class="form-group">
            <label for="enquiryType"
                   class="required">Type of enquiry</label>
            <select id="enquiryType"
                    v-model="$v.form.enquiryType.$model"
                    :class="['form-control',
                    { 'form-control--error': $v.form.enquiryType.$error }]">
              <option v-for="cat in enquiryCategories"
                      :key="cat.id"
                      :value="cat">
                {{ cat.type }}
              </option>
            </select>
            <span v-if="$v.form.lastName.$error"
                  class="validation__error">
              Let us know what your query is about.
            </span>
          </div>
          <!-- email -->
          <div class="form-group">
            <label for="email"
                   class="required">Email Address</label>
            <input id="email"
                   v-model.trim="$v.form.email.$model"
                   type="text"
                   :class="['form-control', { 'form-control--error': $v.form.email.$error }]"
                   placeholder="Email Address">
            <span v-if="$v.form.email.$error"
                  class="validation__error">
              Please enter your email address
            </span>
            <span v-if="$v.form.email.email === false"
                  class="validation__error">
              Please enter a valid email address
            </span>
          </div>
          <!-- telephone -->
          <div class="form-group">
            <label for="tel">Telephone Number</label>
            <input id="tel"
                   v-model.trim="$v.form.telephone.$model"
                   type="number"
                   class="form-control"
                   placeholder="Telephone Number">
          </div>
        </div>
        <!-- right form -->
        <div class="col-lg-6 col-12">
          <!-- message -->
          <div class="form-group">
            <label for="message"
                   class="required">Message</label>
            <textarea
              id="message"
              v-model.trim="$v.form.message.$model"
              :class="['form-control', { 'form-control--error': !$v.form.message.$error }]"
              rows="16"></textarea>

            <span v-if="$v.form.message.$error"
                  class="validation__error">
              Please enter your message/enquiry
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 d-flex justify-content-end">
          <button type="submit"
                  class="action action--accent-one">
            <i class="fas fa-chevron-right"></i>
            Submit Enquiry
          </button>
        </div>
      </div>
      <div v-if="displayAlert"
           class="row">
        <div class="col-12">
          <b-alert :variant="alertVariant"
                   :show="displayAlert"
                   class="my-3 text-center">
            {{ alertMessage }}
          </b-alert>
        </div>
      </div>
      <!-- <template>
        *** Debugging purposes only ***
        <div class="row">
          <div class="col-12">
            <pre>{{ $v }}</pre>
          </div>
        </div>
      </template> -->
    </form>
    <div v-else-if="submitting"
         class="form__submitting">
      <loading-spinner></loading-spinner>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import axios from "axios";
import qs from "qs";
import { VueReCaptcha } from "vue-recaptcha-v3";
import LoadingSpinner from "../LoadingSpinner.vue";

// For more options see below
const siteKey = document.querySelector( "meta[name=\"siteKey\"]" ).getAttribute( "content" );
Vue.use( VueReCaptcha, { siteKey } );

const FORM_STATE = {
  IDLE: "FORM_STATE::IDLE",
  ERROR: "FORM_STATE::ERROR",
  SUBMITTING: "FORM_STATE::SUBMITTING",
  SUCCESS: "FORM_STATE::SUCCESS",
};

export default {
  name: "ContactForm",
  components: {
    LoadingSpinner,
  },
  mixins: [validationMixin],
  props: {
    /*
      A list of enquiry categories containing their respective contact email and type
      i.e. { type: "General", contact: "general@TeamEMC.co.uk" }
    */
    enquiryCategories: {
      type: Array,
      required: true,
      validator: val => {
        const keys = ["id", "type", "contact"];
        return val.every( obj => keys.every( key => key in obj ) );
      },
    },
    errorMessage: {
      type: String,
      default:
        "Oh no, something went wrong! Please try again or contact us if the issue persists. Thank you.",
    },
    successMessage: {
      type: String,
      default: "Success! Thank you for contacting us. We will get back to you as soon as possible.",
    },
  },
  data () {
    return {
      form: {
        firstName: "",
        lastName: "",
        organisation: "",
        postcode: "",
        email: "",
        telephone: "",
        message: "",
        enquiryType: null,
      },
      ui: {
        form: {
          status: FORM_STATE.IDLE,
        },
      },
      FORM_STATE,
    };
  },
  computed: {
    displayForm () {
      const permittedStates = [FORM_STATE.IDLE, FORM_STATE.ERROR, FORM_STATE.SUCCESS];
      return permittedStates.includes( this.ui.form.status );
    },
    displayAlert () {
      // eslint-disable-next-line
      const display =
        this.ui.form.status === FORM_STATE.ERROR || this.ui.form.status === FORM_STATE.SUCCESS;

      return display;
    },
    alertVariant () {
      let variant;
      if ( this.submitting || this.success ) {
        variant = "success";
      } else if ( this.error ) {
        variant = "danger";
      } else {
        variant = "default";
      }
      return variant;
    },
    alertMessage () {
      let message;
      if ( this.submitting || this.success ) {
        message = this.successMessage;
      } else if ( this.error ) {
        message = this.errorMessage;
      } else {
        message = "";
      }
      return message;
    },
    submitting () {
      return this.ui.form.status === FORM_STATE.SUBMITTING;
    },
    error () {
      return this.ui.form.status === FORM_STATE.ERROR;
    },
    success () {
      return this.ui.form.status === FORM_STATE.SUCCESS;
    },
  },
  mounted () {
    const [defaultEnquiryType] = this.enquiryCategories || [null];
    this.form.enquiryType = defaultEnquiryType;
  },
  methods: {
    async getRecaptchaToken () {
      console.table( siteKey );
      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded();
      return this.$recaptcha( "submit" );
    },
    async onSubmit ( event ) {
      event.preventDefault();
      this.$v.$touch();

      if ( this.$v.$invalid ) {
        console.warn( "Form is not valid." );
      } else {
        this.ui.form.status = FORM_STATE.SUBMITTING;

        const url = "/umbraco/Surface/ContactSurface/Submit";
        const token = await this.getRecaptchaToken();

        const {
          firstName,
          lastName,
          organisation,
          postcode,
          email: emailAddress,
          telephone,
          enquiryType: { type, contact },
          message,
        } = this.form;

        const formData = {
          __RequestVerificationToken: this.$csrfToken,
          "g-recaptcha-response": token,
          firstName,
          lastName,
          emailAddress,
          telephone,
          orgName: organisation,
          postcode,
          message,
          enquiryType: type,
          enquiryContact: contact,
        };

        axios
          .post( url, qs.stringify( formData ) )
          .then( ( { status, data } ) => {
            if ( status === 200 && data ) {
              this.resetForm();
              this.ui.form.status = FORM_STATE.SUCCESS;
            } else {
              throw new Error( "Bad response" );
            }
          } )
          .catch( err => {
            this.ui.form.status = FORM_STATE.ERROR;
            console.error( err );
          } );
      }
    },
    resetForm () {
      const formRef = this.form;

      Object.keys( this.form ).forEach( key => {
        formRef[key] = null;
      } );
      this.$v.$reset();
    },
  },
  validations: {
    form: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      organisation: {
        required,
      },
      enquiryType: {
        required,
      },
      telephone: {},
      email: {
        required,
        email,
      },
      message: {
        required,
      },
      postcode: {
        required,
      },
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../Styles/utils/index.less";

@form-control-height: 45px;
@crimson: #d61921;

.form {
  &__wrapper {
    width: 100%;
  }

  &__submitting {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10rem;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

form {
  width: 100%;
}

.validation {
  &__error {
    color: @crimson;
  }
}

.required {
  &::after {
    content: "*";
    color: @color-accent-2;
  }
}

.form-group {
  > input,
  textarea,
  select {
    color: @color-accent-1;
    font-weight: 100;
    border: 1px solid @color-accent-4;
    padding: 2px 8px;

    &::placeholder {
      color: @color-accent-1;
    }
  }

  > input,
  select {
    height: @form-control-height;
    cursor: pointer;
  }

  > select {
    border-radius: 0.5rem;
  }

  > textarea {
    height: 418px;
    resize: vertical;
    padding: 0.5rem 1rem;
  }

  > label {
    color: @color-accent-1;
    font-weight: 500;
  }
}
</style>
